[
  {"id":"modif-ruee","name":"Ruée","description":"+25 % de monstres, +30 % de Kamas.","monsterCountPct":25,"kamasPct":30},
  {"id":"modif-gardien","name":"Gardien éveillé","description":"Gardiens +30 % de PV, Reflets de victoire +50 %.","bossHpPct":30,"victoryRefletsPct":50},
  {"id":"modif-brume","name":"Brume onirique","description":"Monstres +15 % de vitesse, +25 % d'expérience.","monsterSpeedPct":15,"xpPct":25}
]
